import type { ButtonHTMLAttributes, ReactNode } from "react";

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  children: ReactNode;
  variant?: "primary" | "ghost";
};

/** Gold CTA with a subtle glowing hover effect (PRD 2). */
export function Button({ children, variant = "primary", className = "", ...rest }: Props) {
  const base =
    "group relative inline-flex items-center justify-center rounded-full px-7 py-3.5 text-sm font-medium tracking-wide transition-all duration-300 ease-lux focus:outline-none focus-visible:ring-2 focus-visible:ring-gold/60";
  const styles =
    variant === "primary"
      ? "bg-gradient-to-br from-gold-bright to-gold text-[#1A1405] shadow-glow hover:-translate-y-0.5 hover:shadow-[0_0_60px_-6px_rgba(212,175,55,0.7)]"
      : "border border-gold/40 text-obsidian/80 hover:border-gold hover:text-obsidian hover:bg-gold/5";
  return (
    <button className={`${base} ${styles} ${className}`} {...rest}>
      <span className="relative z-10">{children}</span>
      {variant === "primary" && (
        <span
          aria-hidden="true"
          className="pointer-events-none absolute inset-0 rounded-full opacity-0 blur-md transition-opacity duration-300 group-hover:opacity-70 bg-gold"
        />
      )}
    </button>
  );
}
